<template>
  <div class="legal-text" @click="openOverlay">
    {{ $t("age_check.legal_conditions") }}
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: "",
    };
  },
  computed: {
    country() {
      return this.$store.state.country;
    },
    termsOverlayOpen() {
      return this.$store.state.termsOverlay;
    },
  },
  methods: {
    openOverlay() {
      this.$store.commit("setScrollDisabled", false);
      this.$store.commit("setTermsOverlay", true);
    },
  },
};
</script>
<style scoped>
.legal-text {
  font-size: 12px;
  text-transform: uppercase;
  cursor: pointer;
  opacity: 0.5;
  color: #ffffff;
  margin-bottom: 2rem;
  text-align: center;
}

.legal-text:hover {
  opacity: 0.8;
}
</style>
